import { getDefaultStore } from 'jotai';
import { currentPracticeAtom } from '../../lib/practice';
import Practice from './practice';

export default class Ehealth {

  static check_ehealth_interval = () => {
    return 13 * 60 * 1000
  };
  static max_file_size = () => {
    return 3 * 1000 * 1000
  };

  // NOTE: This reads `currentPracticeAtom` from the jotai default store (one-shot
  // read, not a subscription). Call sites must themselves subscribe to
  // `currentPracticeAtom` (via `useAtom`) so they re-render on practice changes;
  // otherwise the module check here may be evaluated against a stale practice.
  static can_check_ehealth = (login) => {
    let can_check_ehealth = false;
    if (!!login && login.type === "User::Coach") can_check_ehealth = true;
    if (!!login && login.type === "User::Restricted") can_check_ehealth = true;

    if (!!can_check_ehealth) {
      const currentPractice = getDefaultStore().get(currentPracticeAtom);
      can_check_ehealth = !!Practice.practice_modules_v3({practice: currentPractice, check: 'ehealth'});
    }

    return can_check_ehealth
  };

  static ehealth_initialised = (login) => {
    let all_okay = false;
    if (!!login && login.type === "User::Coach" && !!login.ehealth?.connection_data) {
      all_okay = (!!login.ehealth?.connection_data.ssin && !!login.ehealth?.connection_data.type && !!login.ehealth?.connection_data.quality);
    }
    if (!!login && login.type === "User::Restricted" && !!login.ehealth?.connection_data) {
      all_okay = (!!login.ehealth?.connection_data.ssin && !!login.ehealth?.connection_data.type && !!login.ehealth?.connection_data.quality);
    }

    return all_okay
  };

  // ssin/type/quality leven op de ehealth-connection; de settings-formulieren
  // lezen ze hieruit en posten ze als ob[extra_data][ehealth][...] (input-compat backend)
  static connection_data = (user) => {
    return (user?.ehealth?.connection_data || {});
  };

  static get_quality = (value) => {
    return {
      "AMBULANCE_RESCUER": "Ambulancier",
      "DOCTOR": "Arts",
      "PHARMACIST": "Apotheker",
      "BIOLOGIST_PHARMACIST": "Apotheker biologist",
      "PHARMACIST_ASSISTANT": "Assistant-apotheker",
      "AUDICIEN": "Audicien",
      "AUDIOLOGIST": "Audioloog",
      "READAPTATION_BACHELOR": "Bachelor in de readaptatiewetenschappen",
      "APPLIED_PSYCH_BACHELOR": "Bachelor in de toegepaste psychologie",
      "FAMILY_SCIENCE_BACHELOR": "Bachelor in gezinwetenschappen",
      "TRUSS_MAKER": "Bandagist",
      "CITIZEN": "Burger",
      "DIETICIAN": "Diëtist",
      "OCCUPATIONAL_THERAPIST": "Ergotherapeut",
      "SPECIALIZED_EDUCATOR": "Gespecialiseerde opvoeder/begeleider",
      "PHYSIOTHERAPIST": "Kinesitherapeut",
      "CLINICAL_ORTHOPEDIC_PEDAGOGUE": "Klinisch orthopedagoog",
      "CLINICAL_PSYCHOLOGIST": "Klinisch psycholoog",
      "LAB_TECHNOLOGIST": "Laborant",
      "LOGOPEDIST": "Logopedist",
      "SOCIAL_WORKER": "Maatschappelijk werker",
      "GERONTOLOGY_MASTER": "Master in de gerontologie",
      "ORTHOPEDAGOGIST_MASTER": "Master in de orthopedagogie",
      "PSYCHOMOTOR_THERAPY": "Master in de psycho-motoriek",
      "DENTAL_HYGIENIST": "Mondhygiënist",
      "OPTICIEN": "Opticien",
      "ORTHOPEDIST": "Orthopedist",
      "ORTHOPTIST": "Orthoptist",
      "PODOLOGIST": "Podoloog",
      "PSYCHOLOGIST": "Psycholoog",
      "DENTIST": "Tandarts",
      "IMAGING_TECHNOLOGIST": "Technoloog in de medischebeeldvorming",
      "IMPLANTPROVIDER": "Verdeler van implantaten",
      "NURSE": "Verpleegkundige",
      "MIDWIFE": "Vroedvrouw",
      "PRACTICALNURSE": "Zorgkundige",
      "AMBU_SERVICE": "Ambulancedienst",
      "PHARMACY": "Apotheek",
      "TREATMENT_CENTER": "Behandelingscentrum",
      "CONSORTIUM": "Consortium kankerbevolkingsonderzoek",
      "CTRL_ORGANISM_EHP": "Controle organisme",
      "LEGAL_PSY": "Forensisch psychiatrisch centrum",
      "ICP": "Geïntegreerd zorgproject",
      "HOME_SERVICES": "Geïntegreerde diensten voor thuisverzorging",
      "OFFICE_DOCTORS": "Groepering van huisartsen op dezelfde installatieplaats",
      "GROUP_DOCTORS": "Groepering van huisartsen op verschillende installatieplaatsen",
      "GROUP": "Groepering van verpleegkundigen",
      "PROT_ACC": "Initiatieven van beschut wonen voor psychiatrische patiënten",
      "LABO": "Laboratorium",
      "MEDICAL_HOUSE": "Medisch huis",
      "INSTITUTION": "Onderneming",
      "PALLIATIVE_CARE": "Palliatieve Zorgen",
      "PSYCH_HOUSE": "Psychiatrische verzorgingstehuis",
      "REEDUCATION": "Rehabitalitatiehuis",
      "RETIREMENT": "Rusthuis",
      "INSTITUTION_EHP": "Speciale door het eHealth-platform erkende entiteit",
      "OTD_PHARMACY": "Tariferingsdienst",
      "SORTING_CENTER": "Triagecentrum",
      "GUARD_POST": "Wachtpost",
      "HOSPITAL": "Ziekenhuis"
    }[value] || "";
  }
}
